export class AsperaDownloadModel {
  authentication: string;
  direction: string;
  fasp_port: number;
  paths: Path[];
  remote_host: string;
  remote_user: string;
  resume: string;
  ssh_port: number;
  target_rate_kbps: number;
  token: string;

  constructor(params: any = {}) {
    this.authentication = params.authentication || 'token';
    this.direction = params.direction || 'receive';
    this.fasp_port = Number(params.faspPort) || 0;
    this.paths = params.path || [];
    this.remote_host = params.remoteHost || '';
    this.remote_user = params.asperaUserName || '';
    this.resume = params.resum || '';
    this.ssh_port = Number(params.sshPort) || 0;
    this.target_rate_kbps = Number(params.targetRateinKBPS) || 0;
    this.token = params.token || '';
  }
}

export interface Path {
  destination: string;
  source: string;
}
